import axios from '@/assets/js/axios'
import Urls from '@/assets/js/Urls'

/**
 * 获取用户所有有效权限
 * @return {*}
 */
export function getAllRightList() {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Right/List/All`,
    method: 'get'
  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch(() => [])
}

/**
 * 获取用户某个产品的有效权限
 * @param {number} productId 产品id
 * @return {*}
 */
export function getRightByProductId(productId) {
  return axios({
    url: `${Urls.DOMAIN_YKT}/Right/List/Product`,
    method: 'get',
    params: {
      productId
    }
  })
    .then(data => {
      return data.result.code === 0 ? data.detail : null
    })
    .catch(() => null)
}
